import * as React from "react";
import PropTypes from "prop-types";
import TAppContent from "../../APP/TAppContent";

class HLAppSideBarAndContent extends React.Component {
    static propTypes = {
        appBarHeight: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        children: PropTypes.any,
        top: PropTypes.number,
    };

    static defaultProps = {
        appBarHeight: 64,
        children: null,
        top: 0,
    };

    render() {
        const styles = {
            appContent: {
                top: this.props.top,
            },
        };

        return (
            <TAppContent style={{ top: styles.appContent.top }} appBarHeight={this.props.appBarHeight}>
                {this.props.children}
            </TAppContent>
        );
    }
}

export default HLAppSideBarAndContent;
